/** GraphQL selection for employee dropdowns (the fields any signed-in user may read: names, no contacts). */
export const EMPLOYEE_DROPDOWN_QUERY = `
  id
  entityId
  personalInfo { firstName lastName }
  enabled
`;
